module.exports = __webpack_public_path__ + "static/media/logo-branca.083d38f6.svg";